import { render } from "./MainApp.vue?vue&type=template&id=195231c0"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=195231c0&lang=css"
script.render = render

export default script